import React, { useRef } from "react";
import AppContainer from "./../../../components/AppContainer/index";
import { Stack } from "@mui/material";
import ExportButton from "../../../components/ExportButton";
import GlobalButton from "../../../components/CustomButton";
import AddReportCardDialog from "./AddReportCardDialog";
import TableData from "../../../dumyData/education/EducationReportCards.json";
import DynamicTable from "../../../components/DynamicTable";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";

const headerData = ["Created At", "Class", "Section", "Term", "Action"];

const displayRows = ["date_time", "class", "section", "term", "actions"];

const AllReportCards = () => {
  const openAddReportCardDialog = useRef();
  const dispatch = useDispatch();
  // Redux states
  const activeTab = useSelector((state) => state.activeTab.tabs);

  const renderRightPart = () => {
    return (
      <Stack
        gap={2}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <ExportButton handleClick={() => console.log("helllo")} />
        <GlobalButton
          btnText={"Create New"}
          handleClickBtn={() =>
            openAddReportCardDialog.current.openDialog({
              data: null,
              type: "add",
            })
          }
          styleProps={{ height: 40, width: "auto" }}
        />
      </Stack>
    );
  };
  return (
    <>
      <AppContainer
        primaryHeading={"All Report Cards"}
        secondaryHeading={"Add,Edit,update and delete report cards"}
        headProps={renderRightPart()}
      >
        <DynamicTable
          tableHeader={headerData}
          displayRows={displayRows}
          tableData={TableData}
          showActions={true}
          showEdit={true}
          showView={true}
          handleEdit={(data) => {
            openAddReportCardDialog.current.openDialog({
              data: data.row,
              type: "edit",
            });
          }}
          handleViewDetail={() => {
            dispatch(
              setActiveTab({
                ...activeTab,
                education_report_card: "ed_report_card_detail",
              })
            );
          }}
        />
      </AppContainer>
      <AddReportCardDialog ref={openAddReportCardDialog} />
    </>
  );
};

export default AllReportCards;
